$(function () {
  const mobileQuery = window.matchMedia(
    "(max-width: 999px), (hover: none) and (pointer: coarse) and (min-width: 600px) and (max-width: 1020px)",
  );
  const storageKey =
    "br_collection_filters_panel_state::" + window.location.pathname;

  let isMobileDevice = mobileQuery.matches;
  let pendingScrollToProducts = false;
  let productScrollTimer = null;
  let panelScrollRestoreTimer = null;
  let restoreQueued = false;
  let panelCloseTimer = null;

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", (event) => {
      isMobileDevice = event.matches;
    });
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener((event) => {
      isMobileDevice = event.matches;
    });
  }

  /**************************************/
  /** BR DESKTOP TOOLBAR SCROLL REVEAL **/
  /**************************************/
  function initDesktopToolbarReveal() {
    const desktopToolbarQuery = window.matchMedia(
      "(min-width: 1025px) and (hover: hover) and (pointer: fine), (min-width: 768px) and (max-width: 1024px) and (hover: none) and (pointer: coarse) and (orientation: portrait), (min-width: 1000px) and (max-width: 1366px) and (hover: none) and (pointer: coarse) and (orientation: landscape)",
    );
    const toolbar = document.querySelector(".br-collection__toolbar");
    if (!toolbar) return;

    let lastScrollY = Math.max(window.scrollY, 0);
    let ticking = false;
    let releaseTimer = null;
    let upwardScrollDistance = 0;
    let revealScrollThreshold = 280;

    const releaseDuration = 220;
    const revealScrollRows = 0.45;

    function updateRevealScrollThreshold() {
      const productGrid =
        document.querySelector("[data-br-load-more-loop]") ||
        document.querySelector("[data-collection-products]");
      const firstProduct = productGrid
        ? productGrid.querySelector(".product-grid-item")
        : null;

      if (!firstProduct) {
        revealScrollThreshold = Math.max(
          220,
          Math.round(window.innerHeight * 0.32),
        );
        return;
      }

      const productHeight = firstProduct.getBoundingClientRect().height;
      const productGridStyle = window.getComputedStyle(productGrid);
      const rowGap = parseFloat(productGridStyle.rowGap) || 0;

      revealScrollThreshold = Math.max(
        220,
        Math.round((productHeight + rowGap) * revealScrollRows),
      );
    }

    function resetToolbarState() {
      window.clearTimeout(releaseTimer);
      toolbar.classList.remove("br-toolbar--unstuck");
      toolbar.classList.remove("br-toolbar--reveal");
      toolbar.classList.remove("br-toolbar--release");
      upwardScrollDistance = 0;
    }

    function revealToolbar() {
      window.clearTimeout(releaseTimer);

      const wasHidden =
        toolbar.classList.contains("br-toolbar--unstuck") ||
        toolbar.classList.contains("br-toolbar--release");

      toolbar.classList.remove("br-toolbar--unstuck");
      toolbar.classList.remove("br-toolbar--release");

      if (wasHidden) {
        toolbar.classList.remove("br-toolbar--reveal");
        void toolbar.offsetWidth;
        toolbar.classList.add("br-toolbar--reveal");
      } else if (!toolbar.classList.contains("br-toolbar--reveal")) {
        toolbar.classList.add("br-toolbar--reveal");
      }
    }

    function releaseToolbar() {
      if (
        toolbar.classList.contains("br-toolbar--unstuck") ||
        toolbar.classList.contains("br-toolbar--release")
      )
        return;

      window.clearTimeout(releaseTimer);

      toolbar.classList.remove("br-toolbar--unstuck");
      toolbar.classList.add("br-toolbar--release");

      requestAnimationFrame(() => {
        toolbar.classList.remove("br-toolbar--reveal");
      });

      releaseTimer = window.setTimeout(() => {
        toolbar.classList.add("br-toolbar--unstuck");
        toolbar.classList.remove("br-toolbar--release");
      }, releaseDuration);
    }

    function unstickToolbarImmediately() {
      window.clearTimeout(releaseTimer);

      if (toolbar.classList.contains("br-toolbar--release")) return;

      toolbar.classList.remove("br-toolbar--reveal");
      toolbar.classList.remove("br-toolbar--release");
      toolbar.classList.add("br-toolbar--unstuck");
    }

    function updateToolbar() {
      const isDesktopToolbar = desktopToolbarQuery.matches;
      const currentScrollY = Math.max(window.scrollY, 0);
      const scrollDelta = currentScrollY - lastScrollY;
      const scrollingDown = scrollDelta > 1;
      const scrollingUp = scrollDelta < -1;
      const atTop = currentScrollY < 2;

      if (!isDesktopToolbar) {
        resetToolbarState();
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      if (atTop) {
        resetToolbarState();
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      if (scrollingDown) {
        upwardScrollDistance = 0;

        if (toolbar.classList.contains("br-toolbar--release")) {
          lastScrollY = currentScrollY;
          ticking = false;
          return;
        }

        if (toolbar.classList.contains("br-toolbar--reveal")) {
          releaseToolbar();
        } else {
          unstickToolbarImmediately();
        }
      } else if (scrollingUp) {
        upwardScrollDistance += Math.abs(scrollDelta);

        if (upwardScrollDistance >= revealScrollThreshold) {
          revealToolbar();
        }
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    function requestToolbarUpdate() {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(updateToolbar);
    }

    updateRevealScrollThreshold();

    window.addEventListener("scroll", requestToolbarUpdate, { passive: true });
    window.addEventListener("resize", updateRevealScrollThreshold);
    window.addEventListener("load", updateRevealScrollThreshold);
    document.addEventListener(
      "br:collection:load-more",
      updateRevealScrollThreshold,
    );

    if (desktopToolbarQuery.addEventListener) {
      desktopToolbarQuery.addEventListener("change", function () {
        updateRevealScrollThreshold();
        updateToolbar();
      });
    } else if (desktopToolbarQuery.addListener) {
      desktopToolbarQuery.addListener(function () {
        updateRevealScrollThreshold();
        updateToolbar();
      });
    }

    updateToolbar();
  }
  initDesktopToolbarReveal();

  function getPanel() {
    return document.querySelector("[data-collection-filters-panel]");
  }

  let brPanelScrollTop = 0;
  let brShouldRestorePanelScroll = false;

  function getFiltersScrollElement() {
    const visiblePanel = document.querySelector(
      ".collection__filters.br-filters--visible [data-collection-filters-form]",
    );

    return visiblePanel || null;
  }

  function rememberFiltersPanelScroll() {
    if (!isMobileDevice) return;

    const scrollElement = getFiltersScrollElement();
    if (!scrollElement) return;

    brPanelScrollTop = scrollElement.scrollTop;
    brShouldRestorePanelScroll = true;
  }

  function restoreFiltersPanelScroll() {
    if (!isMobileDevice || !brShouldRestorePanelScroll) return;

    const scrollElement = getFiltersScrollElement();
    if (!scrollElement) return;

    scrollElement.scrollTop = brPanelScrollTop;
  }

  function saveState(state) {
    sessionStorage.setItem(storageKey, state);
  }

  function unlockThemeScrollLock() {
    document.dispatchEvent(
      new CustomEvent("theme:scroll:unlock", { bubbles: true }),
    );

    requestAnimationFrame(() => {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:unlock", { bubbles: true }),
      );
    });
  }

  function unlockMobileFiltersScrollIfOpen() {
    if (!isMobileDevice) return;

    const panel = getPanel();
    const filters = document.querySelector("[data-collection-filters]");

    if (!panel || !filters) return;
    if (!panel.hasAttribute("open")) return;
    if (!filters.classList.contains("br-filters--visible")) return;

    unlockThemeScrollLock();

    requestAnimationFrame(() => {
      unlockThemeScrollLock();
    });

    window.setTimeout(() => {
      unlockThemeScrollLock();
    }, 120);
  }

  function getProductsScrollTarget() {
    const products = document.querySelector("[data-collection-products]");
    const toolbar = document.querySelector(".br-collection__toolbar");

    if (!products) return null;

    let offset = 12;

    if (toolbar) {
      const toolbarStyle = window.getComputedStyle(toolbar);
      const toolbarTop = parseFloat(toolbarStyle.top);
      const toolbarHeight = toolbar.getBoundingClientRect().height;

      offset += (Number.isFinite(toolbarTop) ? toolbarTop : 0) + toolbarHeight;
    }

    return products.getBoundingClientRect().top + window.pageYOffset - offset;
  }

  function shouldScrollToProductsAfterAjax() {
    const target = getProductsScrollTarget();

    if (target === null) return false;

    return window.pageYOffset > target + 24;
  }

  function markProductScrollIfNeeded() {
    pendingScrollToProducts = shouldScrollToProductsAfterAjax();
  }

  function queueScrollToProductsIfNeeded() {
    if (!pendingScrollToProducts) return;

    if (isMobileDevice && getPanel() && getPanel().hasAttribute("open")) {
      return;
    }

    window.clearTimeout(productScrollTimer);

    productScrollTimer = window.setTimeout(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const target = getProductsScrollTarget();

          if (target === null) return;

          pendingScrollToProducts = false;
          unlockThemeScrollLock();

          window.scrollTo({
            top: Math.max(0, target),
            behavior: "smooth",
          });
        });
      });
    }, 80);
  }

  function mutationTouchesProducts(mutation) {
    const target = mutation.target;

    if (
      target &&
      target.nodeType === 1 &&
      target.closest("[data-collection-products]")
    ) {
      return true;
    }

    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue;

      if (
        node.matches("[data-collection-products]") ||
        node.matches(".collection__products") ||
        node.querySelector("[data-collection-products]") ||
        node.querySelector(".collection__products")
      ) {
        return true;
      }
    }

    return false;
  }

  function restorePanelState() {
    const panel = getPanel();
    const filters = document.querySelector("[data-collection-filters]");
    const savedState = sessionStorage.getItem(storageKey);

    if (!panel) return;

    if (savedState === "open") {
      panel.setAttribute("open", "");

      if (isMobileDevice && filters) {
        filters.classList.add("br-filters--visible");
        filters.classList.remove("collection__filters--visible");
        $(".collection__inner").addClass("filters_activated");
      }
    }

    if (savedState === "closed") {
      panel.removeAttribute("open");

      if (filters) {
        filters.classList.remove("br-filters--visible");
        filters.classList.remove("collection__filters--visible");
      }

      $(".filters_activated").removeClass("filters_activated");
      unlockThemeScrollLock();
    }
  }

  function queueRestore() {
    if (restoreQueued) return;

    restoreQueued = true;
    window.clearTimeout(panelScrollRestoreTimer);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        restoreQueued = false;

        restorePanelState();
        unlockMobileFiltersScrollIfOpen();
        restoreFiltersPanelScroll();

        panelScrollRestoreTimer = window.setTimeout(() => {
          restoreFiltersPanelScroll();
          brShouldRestorePanelScroll = false;
        }, 180);
      });
    });
  }

  function scrollBackToToolbar() {
    if (!isMobileDevice) return;

    const toolbar = document.querySelector(".br-collection__toolbar");
    if (!toolbar) return;

    const offset = 90;
    const elementPosition = toolbar.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  function openFiltersPanel() {
    const panel = getPanel();
    const filters = document.querySelector("[data-collection-filters]");

    if (!panel || !filters) return;

    window.clearTimeout(panelCloseTimer);

    panel.setAttribute("open", "");
    filters.classList.remove("collection__filters--visible");

    requestAnimationFrame(() => {
      filters.classList.add("br-filters--visible");
      $(".collection__inner").addClass("filters_activated");

      unlockMobileFiltersScrollIfOpen();
      saveState("open");
    });
  }

  function closeFiltersPanel(shouldScroll = false) {
    const panel = getPanel();
    const filtersList = document.querySelectorAll("[data-collection-filters]");
    const closeDelay = isMobileDevice ? 360 : 0;

    window.clearTimeout(panelCloseTimer);

    filtersList.forEach((filters) => {
      filters.classList.remove("br-filters--visible");
      filters.classList.remove("collection__filters--visible");
    });

    $(".filters_activated").removeClass("filters_activated");
    brShouldRestorePanelScroll = false;
    saveState("closed");
    unlockThemeScrollLock();

    panelCloseTimer = window.setTimeout(() => {
      if (panel) {
        panel.removeAttribute("open");
      }

      unlockThemeScrollLock();

      if (shouldScroll) {
        if (pendingScrollToProducts) {
          queueScrollToProductsIfNeeded();
        } else {
          scrollBackToToolbar();
        }
      }
    }, closeDelay);
  }

  restorePanelState();

  document.addEventListener("click", function (event) {
    const filterInteraction = event.target.closest(
      ".collection__filters.br-filters--visible .filter__input, .collection__filters.br-filters--visible .collection__sort__input, .collection__filters.br-filters--visible label.filter__button, .collection__filters.br-filters--visible .swatch__label, .collection__filters.br-filters--visible .image__label",
    );

    if (filterInteraction) {
      rememberFiltersPanelScroll();
    }

    const summary = event.target.closest(".collection__filters-summary");

    if (summary) {
      const panel = summary.closest("[data-collection-filters-panel]");
      if (!panel) return;

      if (isMobileDevice) {
        event.preventDefault();
        event.stopPropagation();

        if (
          panel.hasAttribute("open") ||
          document.querySelector(".collection__inner.filters_activated")
        ) {
          closeFiltersPanel(true);
        } else {
          openFiltersPanel();
        }

        return;
      }

      const willOpen = !panel.hasAttribute("open");
      saveState(willOpen ? "open" : "closed");
      return;
    }

    const filtersToggleButton = event.target.closest(
      "[data-br-toggle-filters]",
    );

    if (filtersToggleButton) {
      event.preventDefault();
      event.stopPropagation();
      openFiltersPanel();
      return;
    }

    const closeButton = event.target.closest("[data-br-close-filters]");

    if (closeButton) {
      event.preventDefault();
      closeFiltersPanel(true);
      return;
    }

    const clearAllButton = event.target.closest(".collection__filters__reset");

    if (clearAllButton) {
      markProductScrollIfNeeded();
      closeFiltersPanel(false);
      return;
    }

    const overlay = event.target.closest(".overlay_collection");

    if (overlay) {
      closeFiltersPanel(true);
      return;
    }

    const panel = getPanel();

    if (
      !isMobileDevice &&
      panel &&
      panel.hasAttribute("open") &&
      !event.target.closest("[data-collection-filters-panel]") &&
      !event.target.closest("[data-br-toggle-filters]")
    ) {
      closeFiltersPanel(false);
    }
  });

  document.addEventListener(
    "change",
    function (event) {
      const field = event.target.closest(
        "[data-collection-filters-form] input, [data-collection-filters-form] select",
      );

      if (!field) return;

      rememberFiltersPanelScroll();
      markProductScrollIfNeeded();
    },
    true,
  );

  /************************/
  /** BR LOAD MORE CLICK **/
  /************************/
  function updateLoadMoreCount(button, value, totalOverride = null) {
    if (!button) return;

    const totalItems =
      totalOverride !== null
        ? totalOverride
        : parseInt(button.dataset.totalItems, 10) || 0;

    const loadedItems = Math.min(value, totalItems);
    const countEl = button.querySelector(".pagination__load-more-count");
    const countTemplate = button.dataset.countTemplate || "";

    button.dataset.itemsLoaded = loadedItems;
    button.dataset.totalItems = totalItems;

    if (countEl && countTemplate) {
      const nextText = countTemplate
        .replace("[[product_count]]", loadedItems)
        .replace("[[count]]", totalItems);

      if (countEl.textContent !== nextText) {
        countEl.textContent = nextText;
      }
    }
  }

  function initLoadMoreButtons(root = document) {
    root.querySelectorAll("[data-br-load-more-button]").forEach((button) => {
      const loadedItems = parseInt(button.dataset.itemsLoaded, 10) || 0;
      const totalItems = parseInt(button.dataset.totalItems, 10) || 0;

      updateLoadMoreCount(button, loadedItems, totalItems);
    });
  }

  function finishLoadMore(button) {
    const pagination = button.closest("[data-br-load-more-pagination]");

    button.disabled = true;
    button.classList.add("is-disabled");
    button.dataset.nextUrl = "";

    if (pagination) {
      pagination.remove();
    }
  }

  document.addEventListener("click", function (event) {
    const button = event.target.closest("[data-br-load-more-button]");

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.classList.contains("is-loading")) return;

    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl) return;

    const wrapperId = button.dataset.wrapperId;
    const currentSection =
      (wrapperId && document.getElementById(wrapperId)) ||
      button.closest("[data-section-type='collection-template']");

    if (!currentSection) return;

    const currentGrid = currentSection.querySelector(
      "[data-br-load-more-loop]",
    );
    if (!currentGrid) return;

    button.classList.add("is-loading");
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    fetch(nextUrl, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Next page could not be loaded.");
        }

        return response.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const nextSection = (wrapperId && doc.getElementById(wrapperId)) || doc;

        const nextGrid =
          nextSection.querySelector("[data-br-load-more-loop]") ||
          doc.querySelector("[data-br-load-more-loop]");

        if (!nextGrid) {
          throw new Error("Next product grid not found.");
        }

        const newItems = Array.from(nextGrid.children);
        const fragment = document.createDocumentFragment();

        newItems.forEach(function (item) {
          fragment.appendChild(document.importNode(item, true));
        });

        currentGrid.appendChild(fragment);

        const nextButton =
          nextSection.querySelector("[data-br-load-more-button]") ||
          doc.querySelector("[data-br-load-more-button]");

        if (nextButton && nextButton.dataset.nextUrl) {
          const nextTotalItems =
            parseInt(nextButton.dataset.totalItems, 10) ||
            parseInt(button.dataset.totalItems, 10) ||
            0;

          const nextLoadedItems =
            parseInt(nextButton.dataset.itemsLoaded, 10) ||
            (parseInt(button.dataset.itemsLoaded, 10) || 0) + newItems.length;

          button.dataset.nextUrl = nextButton.dataset.nextUrl;

          if (nextButton.dataset.countTemplate) {
            button.dataset.countTemplate = nextButton.dataset.countTemplate;
          }

          updateLoadMoreCount(button, nextLoadedItems, nextTotalItems);

          button.disabled = false;
        } else {
          const totalItems = parseInt(button.dataset.totalItems, 10) || 0;
          updateLoadMoreCount(button, totalItems, totalItems);
          finishLoadMore(button);
        }

        document.dispatchEvent(
          new CustomEvent("br:collection:load-more", {
            detail: {
              section: currentSection,
              grid: currentGrid,
              items: newItems,
            },
          }),
        );

        document.dispatchEvent(new CustomEvent("theme:scroll"));

        if (window.AOS && typeof window.AOS.refreshHard === "function") {
          window.AOS.refreshHard();
        }
      })
      .catch(function (error) {
        console.error("[BR Load More] Error:", error);
        button.disabled = false;
      })
      .finally(function () {
        button.classList.remove("is-loading");
        button.removeAttribute("aria-busy");
      });
  });

  initLoadMoreButtons();

  const observedRoot =
    document.querySelector("[data-section-type='collection-template']") ||
    document.body;

  const observer = new MutationObserver((mutationList) => {
    let shouldRestore = false;
    let productsChanged = false;

    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        shouldRestore = true;
      }

      if (mutationTouchesProducts(mutation)) {
        productsChanged = true;
      }
    }

    if (shouldRestore) {
      queueRestore();
    }

    if (productsChanged) {
      unlockMobileFiltersScrollIfOpen();
      restoreFiltersPanelScroll();
      initLoadMoreButtons();
      queueScrollToProductsIfNeeded();
    }
  });

  observer.observe(observedRoot, {
    childList: true,
    subtree: true,
  });
});
